import { GetUser } from "./user";

export const SHOPIFY_APP_NAME = "Redo";

export interface Install {
  auth_url: string;
}

export interface AuthResponse {
  authToken: string;
  user: GetUser;
  installationURL?: string;
  url?: string;
}

export enum ShopifyExchangeOrderStrategy {
  ORDER = "order",
  RETURN = "return",
}

export enum ShopifyExchangePaymentStrategy {
  DRAFT_ORDER = "draft_order",
  STRIPE = "stripe",
}

export interface ShopifyIntegration {
  exchangeOrderStrategy: ShopifyExchangeOrderStrategy;
  checkoutOutboundRatesEnabled: boolean;
  hasShopifyPlus: boolean | undefined;
}

export enum InstallSource {
  MAIN_APP = "main",
  ORDER_TRACKING_APP = "order_tracking",
}
